<template>
	<div id="footer">
		<div class="company">
			<div class="info">
				<h5>关于我们</h5>
				<div>
					公司介绍
				</div>
				<div>
					发展历程
				</div>
				<div>
					业务生态
				</div>
				<div>
					企业荣誉
				</div>
				<div>
					专利证书
				</div>
				<div>
					软件著作权
				</div>
			</div>
			<div class="info">
				<h5>核心业务</h5>
				<div>
					特色产品
				</div>
				<div>
					综合服务
				</div>
				<div>
					供应链业务
				</div>
				<div>
					新零售业务
				</div>
				<div>
					创投孵化
				</div>
			</div>
			<div class="info">
				<h5>项目中心</h5>
				<div>
					人工智能
				</div>
				<div>
					文旅产业
				</div>
				<div>
					智慧康养
				</div>
				<div>
					教育培训
				</div>
			</div>
			<div class="info4">
				<div class="info_list">
					<van-collapse :boder="boderD" v-model="activeName" accordion class="ninini">
						<van-collapse-item :boder="boderD" title="关于我们" name="1">
							<div>
								公司介绍
							</div>
							<div>
								发展历程
							</div>
							<div>
								业务生态
							</div>
							<div>
								企业荣誉
							</div>
							<div>
								专利证书
							</div>
							<div>
								软件著作权
							</div>
						</van-collapse-item>
						<van-collapse-item :boder="boderD" title="核心业务" name="2">
							<div>
								特色产品
							</div>
							<div>
								综合服务
							</div>
							<div>
								供应链业务
							</div>
							<div>
								新零售业务
							</div>
							<div>
								创投孵化
							</div>
						</van-collapse-item>
						<van-collapse-item :boder="boderD" title="企业介绍" name="3">
							<div>
								客服电话：{{info.phone}}
							</div>
							<div>
								邮件：{{info.czNum}}
							</div>
							<div>
								公司名称：{{info.webName}}
							</div>
							<div>
								地址：{{info.address}}
							</div>
						</van-collapse-item>
					</van-collapse>
				</div>

				<div class="info5">
					<h5>企业介绍</h5>
					<div>
						客服电话：{{info.phone}}
					</div>
					<div>
						邮件：{{info.czNum}}
					</div>
					<div>
						公司名称：{{info.webName}}
					</div>
					<div>
						地址：{{info.address}}
					</div>
				</div>

			</div>



			<div class="gzg_info">
				<p>股票交易代码：{{info.tradeNum}}</p>
				<div>
					<img :src="info.codeImg" alt="" />
					<div>关注公众号</div>
				</div>

			</div>
		</div>
		<div class="record">
			<div>
				<span>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index"
						target="_blank">{{info.icpNum}}</a><span>版权：©2025 农夫铺子发展集团有限公司 版权所有</span>
				</span>
			</div>
			<div></div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	export default {
		name: "Footer",
		data() {
			return {
				boderD: false,
				activeName: '',
				info: '',
				domain: '',
			};
		},
		mounted() {
			// 如果需要包含协议，可以这样组合
			this.domain = `${window.location.protocol}//${window.location.hostname}`;
			this.getInfo()
		},
		methods: {
			getInfo() {
				// 发起 POST 请求
				axios.post('/index/webSite')
					.then(response => {
						// console.log('响应数据:', response.data);
						this.info = response.data.data
					})
					.catch(error => {
						console.error('请求出错:', error);
					});
			},
		}
	};
</script>
<style>
	/* 消除折叠面板项的外层边框 */
	::v-deep .van-collapse-item {
		border: none !important;
	}

	/* 消除面板头部的下边框（展开/收起时的分隔线） */
	::v-deep .van-collapse-item__header {
		border-bottom: none !important;
	}

	/* 消除面板内容区的边框（若有） */
	::v-deep .van-collapse-item__content {
		border: none !important;
	}

	/* 可选：消除折叠面板容器的整体边框（如需） */
	::v-deep .van-collapse {
		border: none !important;
	}

	.van-cell,
	.van-collapse-item__content {
		background: none;
		padding: 10px 0;
		color: #666666;

	}
</style>
<style scoped>
	#footer {
		height: 357px;
		transition: all ease 0.6s;
		background: #FBFBFB;
		box-sizing: border-box;
		text-align: left;
		color: #666666;
	}

	.company {
		width: 57%;
		margin: 0 auto;
		/* height: 277px; */
		box-sizing: border-box;
		color: #666666;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #CCCCCC;
	}

	.record {
		height: 80px;
		box-sizing: border-box;
		background: #FBFBFB;
		padding: 20px;
		font-size: 12px;
		color: #666666;
		display: flex;
		justify-content: space-around;
		text-align: center;
	}



	.gzg_info img {
		width: 120px;
		height: 120px;
		margin: 0 auto;
		margin-top: 34px;
	}

	.gzg_info {
		text-align: center;
		margin-top: 50px;
	}

	.gzg_info p {
		margin: 0;
		font-weight: bold;
		font-size: 20px;
		color: #222;
	}

	.gzg_info div {
		color: #666666;
		font-size: 14px;
		margin-top: 15px;
	}

	.record img {
		width: 36px;
		height: 40px;
		display: inline-block;
	}



	.record span {
		margin-left: 14px;
	}

	.info,
	.info4 {
		margin-top: 50px;

	}

	.info div,
	.info4 div {
		line-height: 30px;
		color: #666666;
		font-size: 14px;
	}

	.info h5,
	.info4 h5 {
		font-weight: 800;
		color: #222222;

	}

	@media screen and (min-width:998px) {
		.company {
			height: 277px;
		}

	}

	.info_list {
		display: none;
	}



	@media screen and (max-width: 997px) {
		.info5 {
			display: none;
		}

		.info_list {
			width: 100%;
			display: inline-block;
		}

		/* 消除折叠面板项的外层边框 */
		::v-deep .van-collapse-item {
			border: none !important;
		}

		/* 消除面板头部的下边框（展开/收起时的分隔线） */
		::v-deep .van-collapse-item__header {
			border-bottom: none !important;
		}

		/* 消除面板内容区的边框（若有） */
		::v-deep .van-collapse-item__content {
			border: none !important;
		}

		/* 可选：消除折叠面板容器的整体边框（如需） */
		::v-deep .van-collapse {
			border: none !important;
		}

		.title {
			font-size: 20px;
		}

		.address_tel_fax {
			font-size: 12px;
		}

		.email_wx {

			font-size: 12px;
		}

		.copy {
			font-size: 12px;
			margin: 30px 0 10px;
		}

		.info {
			display: none;
		}

		.info4 {

			margin-top: 0px;
		}

		.info4 div {
			color: #999;
			font-size: 12px;
		}

		.company {
			width: 90%;
			padding-top: 30px;
			display: inline-block;
			margin-left: 5%;
			border: none;
			/* height: 220px; */
		}

		#footer {
			/* height: 300px; */
		}

		.record span {
			font-size: 10px;
			text-align: left;
			display: inline-block;
			margin-left: 0;
		}


		.gzg_info {
			display: flex;
			justify-content: space-between;
			border-top: 1px solid #e1e1e1;
			border-bottom: 1px solid #e1e1e1;
			padding: 25px 15px;
			margin-top: 25px;
		}

		.gzg_info p {
			font-weight: 500;
			font-size: 14px;
			color: #222222;
			line-height: 80px;
		}

		.gzg_info div {
			margin-top: 0;
			font-size: 12px;
		}

		.gzg_info img {
			margin-top: 0;
			width: 60px;
			height: 60px;
			margin-bottom: 10px;
		}


	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue